import { render, staticRenderFns } from "./PostEditComponent.vue?vue&type=template&id=546a51dd&scoped=true&"
import script from "./PostEditComponent.vue?vue&type=script&lang=js&"
export * from "./PostEditComponent.vue?vue&type=script&lang=js&"
import style0 from "./PostEditComponent.vue?vue&type=style&index=0&id=546a51dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546a51dd",
  null
  
)

export default component.exports